import React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useMediaQuery, useTheme } from "@mui/material";
import TableRowsPerPageSection from "./TableRowsPerPageSection";

export default function TablePaginationSection({
  count, // total number of pages calculated as Math.ceil(total / rowsPerPage)
  page,
  total, // total number of records matching the filter
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
}) {
  // Use custom breakpoints for more aggressive responsive behavior
  const isVeryLargeScreen = useMediaQuery('(min-width: 1400px)');
  const isLargeScreen = useMediaQuery('(min-width: 1100px)');
  const isMediumScreen = useMediaQuery('(min-width: 800px)');
  const isSmallScreen = useMediaQuery('(min-width: 600px)');
  console.log("Screen size flags:", { isSmallScreen, isMediumScreen, isLargeScreen, isVeryLargeScreen });
  // Determine siblingCount based on screen size
  const getSiblingCount = () => {
    if (!isSmallScreen) return 0; // Extra small: Show only current page + prev/next
    if (!isMediumScreen) return 0; // Small: Show only current page + prev/next  
    if (!isLargeScreen) return 0; // Medium: Show 1 page on each side of current
    if (!isVeryLargeScreen) return 0; // Large: Show 1 page on each side of current
    return 2; // Very large: Show 2 pages on each side of current
  };
  
  // Also adjust boundaryCount for smaller screens
  const getBoundaryCount = () => {
    if (!isSmallScreen) return 0; // Don't show first/last page numbers on very small screens
    if (!isMediumScreen) return 0; // Don't show first/last page numbers on small screens
    return 1; // Show first and last page numbers on medium+ screens
  };
  console.log("Pagination config:", { siblingCount: getSiblingCount(), boundaryCount: getBoundaryCount() });
  const startRecord = (page - 1) * rowsPerPage + 1;
  const endRecord = Math.min(startRecord + rowsPerPage - 1, total);

  return (
    <Grid
      style={{
        position: "relative",
        minHeight: "8vh",
        marginTop: "auto",
        bottom: 0,
        marginBottom: 28,
        maxwidth: "calc(90vw - 160px)",
      }}
    >
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        style={{ position: "absolute", bottom: 0, width: "100%" }}
      >
        <Pagination
          count={count}
          page={page}
          onChange={onPageChange}
          siblingCount={getSiblingCount()}
          boundaryCount={getBoundaryCount()}
          renderItem={(item) => (
            <PaginationItem
              component={(props) => (
                <IconButton
                  {...props}
                  color="primary"
                  style={{
                    marginLeft: 0,
                    background: "#fff",
                  }}
                >
                  {item.type === "previous" ? (
                    <Grid container alignItems={"center"}>
                      <ArrowBackIosIcon
                        fontSize="small"
                        style={{ color: "#00A7CD" }}
                      />{" "}
                      <span>Prev</span>
                    </Grid>
                  ) : item.type === "next" ? (
                    <Grid container alignItems={"center"}>
                      <span> Next </span>
                      <ArrowForwardIosIcon
                        fontSize="small"
                        style={{ color: "#00A7CD" }}
                      />
                    </Grid>
                  ) : (
                    <span
                      style={{
                        color: item.page === page ? "#00A7CD" : "#020303",
                      }}
                    >
                      {item.page}
                    </span>
                  )}
                </IconButton>
              )}
              {...item}
            />
          )}
        />
        <TableRowsPerPageSection
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        />
        <span
          style={{
            color: "#00A7CD",
            paddingLeft: 10,
          }}
        >
          {`${count === 0 ? 0 : startRecord}-${endRecord} of ${total}`}
        </span>
      </Grid>
    </Grid>
  );
}

const prevButtonStyles = {
  color: "#00A7CD",
  fontSize: 14,
  fontWeight: 700,
  marginLeft: 10,
  fontFamily: "Avenir Book, sans-serif",
};

const nextButtonStyles = {
  color: "#00A7CD",
  fontSize: 14,
  fontWeight: 700,
  marginRight: 10,
  fontFamily: "Avenir Book, sans-serif",
};

const pageNumberStyles = {
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};
